const Q = require('q');
const _ = require('underscore/underscore-min');
const ExceptionService = require('exceptions/exception-service.js');
const reqwest = require('reqwest/reqwest.min');
const endpoints = require('endpoint/endpoint-service.js');

const ProgressService = (function (root, doc, undefined) {

    const filename = 'progress-service.js';

    const logError = (message, data) => {
        ExceptionService.handle('warning', { filename, message, data });
    };

    /**
     * Returns full progress for the current
     * authenticated user based on a given learning course language.
     * @param  {string} language
     * @return {promise}
     */
    const get = (language) => {

        const defer = Q.defer();

        const onSuccess = (response) => {
            defer.resolve(response);
        };

        const onError = (error) => {
            const message = 'get() - Can\'t retrieve progress';
            logError(message, error);
            defer.reject(message);
        };

        if(!language){
            onError('TECHNICAL_ISSUE');
            return defer.promise;
        }

        let url = endpoints.generateEndpoint('courseProgress');
        url = url.replace('{language}', language);

        reqwest({
            url: url,
            method: 'get',
            type: 'json',
            contentType: 'application/json',
            withCredentials: true
        }).then(onSuccess, onError);

        return defer.promise;

    };

    /**
     * Indicates wether or not
     * a given progress has finished an activity
     * based on a specific language.
     * @param  {object}  progress
     * @param  {string}  language
     * @return {boolean}
     */
    const hasCompletedAnActivity = (progress, language) => {
        if(!progress || !progress[language]){
            return false;
        }
        return _.some(progress[language], (value, key) => {
            return key.indexOf('activity') !== -1;
        });
    };

    return {
        get,
        hasCompletedAnActivity
    };

})(window, document);

module.exports = ProgressService;
